var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticStyle:{"height":"30px","margin-right":"5px"},attrs:{"size":"small","icon":"md-create","type":"warning"},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._v("编辑")])}
var staticRenderFns = []

export { render, staticRenderFns }